import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const Spinner = ({ loading = false }) => {
  const applicationLoading = useSelector(
    state => state.forms.applicationLoading
  );
  const shouldDisplay = loading || applicationLoading;

  useEffect(() => {
    const body = document.querySelector('body');
    if (shouldDisplay) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }
  }, [shouldDisplay]);

  return shouldDisplay ? (
    <div id={'spinner'} className={'custom-spinner'}>
      <Spin size="large" />
    </div>
  ) : null;
};

Spinner.propTypes = {
  loading: PropTypes.bool,
};

export default Spinner;
